import React from 'react'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'

import { Wrapper, Container, TextWrap, Title, Text, Image } from './style'

export default function NascemosParaFacilitar() {
	const { data, isLoading } = useFetchContent()
	const {
		tituloTopo,
		descricaoTopo,
		corDeFundoTopo,
		textColor,
		imagemTopo
	} = getSection({ sectionName: 'landingDoubleSection', data })

	if(isLoading || !data) return <Loading />

	return (
		<Wrapper style={{ backgroundColor: corDeFundoTopo }}>
			<Container>
				<Image
					src={`https://${imagemTopo.fields.file.url}`}
					alt={imagemTopo.fields.title}
				/>
				<TextWrap>
					<Title color={textColor}>{tituloTopo}</Title>
					<Text color={textColor}>{descricaoTopo}</Text>
				</TextWrap>
			</Container>
		</Wrapper>
	)
}
